// `revenue.reversal.v1` — the marketing-internal Inngest payload the
// revenue-reversal bridge emits (PE-1768) after consuming `refund.issued.v1`
// or `dispute.status-changed.v1` off the shared bus. Consumed by the marketing
// worker's `revenue-reversal` Inngest function, which recomputes the credited
// broadcast's "$ Raised" rollup.
//
// Producer: marketing-backend (revenue-reversal-bridge Lambda).
// Consumer: marketing-backend worker (workflows/revenue-reversal.ts).
//
// Deliberately SLIM — everything the workflow needs and nothing it could
// misuse (no amounts: the rollup is recompute-never-increment, so carrying an
// amount would only invite incremental arithmetic).
//
// Inngest event name: `marketing/revenue.reversal.v1`
// (REVENUE_REVERSAL_INNGEST_EVENT). Not an EventBridge detail-type — this is
// the intra-service leg; the bus legs are refund.issued.v1 /
// dispute.status-changed.v1.
//
// Status: active

import { z } from 'zod';

import { eventEnvelopeSchema } from './base.js';

export const revenueReversalV1Schema = eventEnvelopeSchema.extend({
  // The refunded/disputed donation's per-charge transaction id — the
  // workflow's only lookup handle (donations index → credited broadcast).
  transactionId: z.string().min(1).max(256),
  // Which bus event produced this — logs/metrics only; the workflow's
  // behavior is identical for both.
  reversalKind: z.enum(['REFUND', 'DISPUTE']),
});

export type RevenueReversalV1 = z.infer<typeof revenueReversalV1Schema>;
